import React from 'react'
import PropTypes from 'prop-types'
import Header from 'gatsby-theme-leshen/src/components/Header'
import Footer from 'gatsby-theme-leshen/src/components/Footer'

const Layout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
